import { fetch } from 'http-common';

interface SubCategory {
  id?: string;
  nameIt: string;
  nameEn: string;
}

interface CategoryDto {
  id?: string;
  seasonLine: string;
  nameIt: string;
  nameEn: string;
  subCategories?: SubCategory[];
}

interface CategoryRequestBody {
  categoryDto: CategoryDto;
  subCategoryDtos: SubCategory[];
}

interface CategoryResponse {
  id: string;
  seasonLine: string;
  nameIt: string;
  nameEn: string;
  subCategories: SubCategory[];
}

class CategoryDataService {
  private http = fetch();

  private ep = '/v1/categories';

  public async getAll() {
    return this.http.get<CategoryResponse[]>(this.ep);
  }

  public async getById(id: string) {
    return this.http.get<CategoryResponse>(`${this.ep}/${id}`);
  }

  public async create(data: CategoryRequestBody) {
    return this.http.post<CategoryResponse>(this.ep, data);
  }

  public async edit(id: string, data: CategoryRequestBody) {
    return this.http.put<CategoryResponse>(`${this.ep}/${id}`, data);
  }

  public async delete(id: string) {
    return this.http.delete(`${this.ep}/${id}`);
  }
}

const categoryDataService = new CategoryDataService();

export { categoryDataService };
export type { CategoryDto, CategoryRequestBody, CategoryResponse, SubCategory };
